import { render } from "./CreacionRecomendadosView.vue?vue&type=template&id=464e164b"
import script from "./CreacionRecomendadosView.vue?vue&type=script&lang=js"
export * from "./CreacionRecomendadosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__